import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../../partials/LoadingSpinner';

import UpdateThresholdModal from './UpdateThresholdModal';
import DeleteThresholdModal from './DeleteThresholdModal';

import { thresholdsIndex } from '../../../redux/actions/thresholds';

const ThresholdList = ({ payload, thresholds, continuationToken, getThresholdsPage }) => {
  const [submitted, setSubmitted] = useState(false);
  const [activeThreshold, setActiveThreshold] = useState(null);
  const [showEditThresholdModal, setShowEditThresholdModal] = useState(false);
  const [showDeleteThresholdModal, setShowDeleteThresholdModal] = useState(false);
  const [modalY, setModalY] = useState(0);

  const [page, setPage] = useState(0);

  useEffect(() => {
    getNextThresholdPage();
  }, []);

  const showEditModal = (event, threshold) => {
    setModalY(event.pageY);
    setActiveThreshold(threshold);
    setShowEditThresholdModal(true);
  }

  const showDeleteModal = (event, threshold) => {
    setModalY(event.pageY);
    setActiveThreshold(threshold);
    setShowDeleteThresholdModal(true);
  }

  const getPreviousThresholdsPage = () => {
    let previousContinuationToken = thresholds.thresholdsSearchStack[page - 2];
    getThresholdsPage(payload, previousContinuationToken.id, (page - 1));
    setPage(page - 1);
  }

  const getNextThresholdPage = () => {
    getThresholdsPage(payload, thresholds.thresholdsSearchStack[page].id, (page + 1));
    setPage(page + 1);
  }

  const itemName = (threshold) => {
    if(threshold?.product_data?.name) {
      return threshold?.product_data?.name;
    }

    if(threshold?.variation_data?.name) {
      return threshold?.variation_data?.name;
    }

    let relatedProduct = thresholds.relatedProducts?.find(related => parseInt(threshold.product_id) === related.id);

    if(relatedProduct) {
      return relatedProduct.name;
    }
  }

  const itemImageUrl = (threshold) => {
    if(threshold?.product_data?.smallThumbnailUrl) {
      return threshold?.product_data?.smallThumbnailUrl;
    }

    if(threshold?.variation_data?.smallThumbnailUrl) {
      return threshold?.variation_data?.smallThumbnailUrl;
    }

    let relatedProduct = thresholds.relatedProducts?.find(related => parseInt(threshold.product_id) === related.id);

    if(relatedProduct) {
      return relatedProduct.smallThumbnailUrl;
    }
  }


  return(
    <>
      <div>
        { thresholds.isFetching &&
          <LoadingSpinner statusText="Loading Thresholds" />
        }

        { thresholds.thresholds.length === 0 && !thresholds.isFetching &&
          <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
            <div className="a-card__paddings text-center">
              <p>No thresholds found. Add inventory thresholds to see them listed here.</p>
            </div>
          </div>
        }

        { thresholds.thresholds.length > 0 &&
          <>
            <div className="flex-container">
              <div className="flex-1">
                <button
                  className="btn btn-default"
                  onClick={() => getPreviousThresholdsPage()}
                  disabled={page === 1}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.284 9.9992H15c.5523 0 1-.4477 1-1 0-.5522-.4477-1-1-1H5.284l2.7725-3.0035c.3746-.4059.3493-1.0385-.0565-1.4131-.4058-.3746-1.0385-.3493-1.413.0565L2.2651 8.321a1 1 0 0 0 0 1.3565l4.3217 4.6819c.3746.4058 1.0073.4311 1.4131.0565.4058-.3746.4311-1.0072.0565-1.4131L5.284 9.9992z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Previous Thresholds</span>
                </button>

                <button
                  className="btn btn-default"
                  onClick={() => getNextThresholdPage()}
                  disabled={thresholds.lastPage}
                >
                  <span className="gwt-InlineLabel">Next Thresholds</span>
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.716 9.9992H3c-.5523 0-1-.4477-1-1 0-.5522.4477-1 1-1h9.716L9.9435 4.9958c-.3746-.4059-.3493-1.0385.0565-1.4131.4058-.3746 1.0385-.3493 1.4131.0565l4.3217 4.6819a1 1 0 0 1 0 1.3565l-4.3217 4.6819c-.3746.4058-1.0073.4311-1.4131.0565-.4058-.3746-.4311-1.0072-.0565-1.4131l2.7725-3.0036z"/></svg>
                  </span>
                </button>
              </div>
            </div>



            <div className="zebra-stripe-children">
              { thresholds.thresholds.map(threshold =>
                <lineitem>
                  <div className="has-hover sku-line">
                    <h4>{ threshold.variation_id ? 'Variation' : 'Product'} - { itemName(threshold) }</h4>
                    <div className="flex-container">
                      <div className="left-15">
                        { itemImageUrl(threshold) &&
                          <img src={itemImageUrl(threshold)} />
                        }
                      </div>
                      <div className="flex-2">
                        <div className="left-15">
                          <h4>Inventory Thresholds</h4>
                          <ul>
                            <li>Target Inventory: <span className="inline-text-tag">{threshold.target_inventory || "Not set"}</span> </li>
                            <li>Low Inventory: <span className="inline-text-tag">{threshold.low_inventory || "Not set"}</span></li>
                            <li>Critical Inventory: <span className="inline-text-tag">{threshold.critical_inventory || "Not set"}</span></li>
                          </ul>
                        </div>
                      </div>


                      <div className="flex-2">
                        <h4>Item Details</h4>
                        <ul>
                          { threshold?.variation_data?.options && threshold?.variation_data?.options.map(option =>
                              <li>
                                <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                              </li>
                            )
                          }
                        </ul>
                      </div>
                      <div className="flex-1">
                        <div className="left-15">
                          <button
                            className={`btn btn-default ${thresholds.updatingThresholds.find(thresholdId => thresholdId === `${threshold.product_id}/${threshold.variation_id}`) ? 'btn-loading' : ''}`}
                            onClick={(event) => showEditModal(event, threshold)}
                            disabled={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${threshold.product_id}/${threshold.variation_id}`)}
                            isLoading={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${threshold.product_id}/${threshold.variation_id}`)}
                          >
                            <span className="svg-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                            </span>
                            <span className="gwt-InlineLabel">Edit Thresholds</span>
                          </button>
                          <br/>
                          <br/>
                          <button
                            className={`btn btn-default btn--destructive ${thresholds.updatingThresholds.find(thresholdId => thresholdId === `${threshold.product_id}/${threshold.variation_id}`) ? 'btn-loading' : ''}`}
                            onClick={(event) => showDeleteModal(event, threshold)}
                            disabled={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${threshold.product_id}/${threshold.variation_id}`)}
                            isLoading={thresholds.updatingThresholds.find(thresholdId => thresholdId === `${threshold.product_id}/${threshold.variation_id}`)}
                          >
                            <span className="svg-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M7 0h4l1 2H6l1-2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1v11c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2V5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2zm12 13V5H4v11h10z"/><path d="M6 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6zM10 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6z"/></svg>
                            </span>
                            <span className="gwt-InlineLabel">Remove Thresholds</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr/>
                </lineitem>
              )}
            </div>

          </>
        }

      </div>

      { showEditThresholdModal &&
        <UpdateThresholdModal
          payload={payload}
          showUpdateThresholdModal={showEditThresholdModal}
          setShowUpdateThresholdModal={setShowEditThresholdModal}
          threshold={activeThreshold}
          thresholdName={itemName(activeThreshold)}
          modalY={modalY}
        />
      }
      { showDeleteThresholdModal &&
        <DeleteThresholdModal
          payload={payload}
          showDeleteThresholdModal={showDeleteThresholdModal}
          setShowDeleteThresholdModal={setShowDeleteThresholdModal}
          threshold={activeThreshold}
          thresholdName={itemName(activeThreshold)}
          modalY={modalY}
        />
      }
    </>
  )

}

const mapStateToProps = state => ({
  thresholds: state.thresholds,
  continuationToken: state.thresholds.thresholds?.continuationToken,
});

const mapDispatchToProps = (dispatch) => ({
  getThresholdsPage: (payload, continuationToken, page) => dispatch(thresholdsIndex(payload, continuationToken, page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThresholdList);

